import GiftDetailContainer from './GiftDetailContainer';
export default GiftDetailContainer;
